import { Chip, Stack } from '@mui/material';
import { t } from 'i18next';
import { MemberDetailPopover } from 'src/modules/member/components/memberDetailPopover';
import { Member } from 'src/modules/member/models/member';

type RecipientListProps = {
  members: Member[];
};
export const RecipientList = (props: RecipientListProps) => {
  const { members } = props;

  return (
    <Stack direction='row' spacing={1} sx={{ flexWrap: 'wrap' }}>
      {members.length > 0 &&
        members.map((item) => {
          const hasName = item.firstName && item.lastName;
          return (
            <MemberDetailPopover member={item} key={item.member_id}>
              <Chip
                label={hasName ? `${item.firstName} ${item.lastName}` : t('member:nameIsMissing')}
                sx={{ mb: 0.5, fontStyle: hasName ? 'normal' : 'italic' }}
              />
            </MemberDetailPopover>
          );
        })}
    </Stack>
  );
};
